import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { BTImportRequest } from "../shared/BTImportRequest";
import { DataService_BusTrackerBusMaintenance } from "../shared/data.service";

@Component({
	selector: "app-bus-tracker-import",
	templateUrl: "./bus-tracker-import.component.html",
	styleUrls: ["./bus-tracker-import.component.css"],
})
export class BusTrackerImportComponent implements OnInit {
	constructor(private busService: DataService_BusTrackerBusMaintenance, private ref: DynamicDialogRef, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadFormatOptions();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	LoadingOptions: any = true;
	IsProcessing: any = false;

	FormatOption: any;
	lstFormatOptions: any = [];

	ImportFile: any; //Data, ex. ImportFile.name
	ImportData: any = ""; //Base 64

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingOptions = true;

		var result = this.busService.BusTrackerFormatSelectList();
		result.subscribe(
			(response) => {
				this.LoadingOptions = false;

				this.lstFormatOptions = response;

				for (var z = 0; z < this.lstFormatOptions.length; z++) {
					var next = this.lstFormatOptions[z];

					if (next.Selected == true) {
						this.FormatOption = next;
						break;
					}
				}
			},
			(error) => {
				this.LoadingOptions = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onSelectFile() {
		this.errorMessage = "";

		document.getElementById("ImportInput").click();
	}

	onImport() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		//No Data
		if (this.ImportData == "") {
			this.errorMessage = "Select a file to import";
			return;
		}

		//Bad Format
		if (String(this.ImportFile.type) != "text/plain" && String(this.ImportFile.type) != "text/csv") {
			this.errorMessage = "Invalid format";
			return;
		}

		this.ConfirmImport();
	}

	ConfirmImport() {
		this.confirmationService.confirm({
			key: "confirmimport",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"You are about to run the import process on your file. This will DEACTIVATE buses, routes, and route types not in the file. It will also DELETE student route assignments that are missing from the file. NOTE: It is recommended that you EXPORT your data, change it, and then import it. Do you want to continue?",
			header: "Confirm Import",
			icon: "fa",
			accept: () => {
				this.FinishImport();
			},
			reject: () => {},
		});
	}

	FinishImport() {
		this.IsProcessing = true;

		let parms: BTImportRequest = {
			FormatOption: this.FormatOption.ID,
			ImportDataBase64: this.ImportData,
		};

		var result = this.busService.BusTrackerImport(parms);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				if (this.AllClear(response)) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "import",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Successfully imported Buses, Routes, Students, and Route Types",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "import",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not import Bus Tracker data",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	onClose() {
		this.errorMessage = "";

		this.ref.close("close");
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////

	onFileToImportChange(val) {
		// console.log("Import File Changed");
		// console.log(val);

		this.ImportFile = val.target.files[0];

		// console.log("Import File");
		// console.log(this.ImportFile);

		var fr = new FileReader();
		fr.readAsDataURL(this.ImportFile);

		fr.onload = () => {
			this.FinishLoadFile(fr.result);
		};
	}

	FinishLoadFile(f) {
		this.ImportData = f;
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingOptions == true || this.IsProcessing == true;
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	/////////////////////////////////////////////////////////////////////
}
